"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.repeat_password.placeholder': '重复密码',
};
